import React, { useMemo } from 'react';

import { ThemeProvider } from '@mui/material/styles';
import { deepmerge } from '@mui/utils';

import { lightTheme, darkTheme } from '@common/theme';
import { useGlobalContext } from '@hooks/Context/GlobalContext';

import brandAokBlue from '../../brandingConfig/brandAokBlue.json';
import brandAokDefault from '../../brandingConfig/brandAokDefault.json';
import brandDefault from '../../brandingConfig/default.json';
import defaultDark from '../../brandingConfig/defaultDark.json';
import brandFraunhofer from '../../brandingConfig/fraunhofer.json';
import brandGreen from '../../brandingConfig/green.json';
import brandLayherDefault from '../../brandingConfig/layher-default.json';
import brandLayherSteigtechnik from '../../brandingConfig/layher-steigtechnik.json';

const Theme = ({ children }) => {
  const [contextData] = useGlobalContext();
  const { colorMode } = contextData;

  const newParams = new URLSearchParams(window.location.search);
  const styleFlag = newParams.get('st') || null;
  if (styleFlag) {
    window.localStorage.setItem('styleFlag', styleFlag);
  }

  const styleFlagLocalStorage = window.localStorage.getItem('styleFlag');

  const styleConfig = useMemo(() => {
    const brand = import.meta.env.VITE_CLIENT_BRAND ?? 'default';
    const brandConfigMap = {
      fraunhofer: [brandFraunhofer, brandFraunhofer],
      layher: [brandLayherDefault, brandLayherSteigtechnik],
      orbis: [brandDefault, brandGreen],
      aok: [brandAokDefault, brandAokBlue],
      default: [brandDefault, brandGreen]
    };

    const [brand1, brand2] = brandConfigMap[brand] || brandConfigMap['default'];

    const config = styleFlagLocalStorage === '1' ? deepmerge(brand1, brand2) : brand1;

    return Object.freeze(config);
  }, [styleFlagLocalStorage]);

  const theme = useMemo(() => {
    const baseTheme = colorMode === 'light' ? lightTheme : darkTheme;
    const extra = colorMode === 'dark' ? defaultDark : {};
    return deepmerge(baseTheme, deepmerge(styleConfig, extra));
  }, [colorMode, styleConfig]);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default Theme;
